export const LicenseTypes = {
  Limited: 'limited',
  Unlimited: 'unlimited',
}
